import { createAsyncThunk } from '@reduxjs/toolkit'
import { instance } from '../api/api'

export type ServiceType = {
  id: number
  name: string
  createdAt?: string
  updatedAt?: string
}

export const getServices = createAsyncThunk(
  'services/getServices',
  async ({ token }: { token: string }, thunkAPI) => {
    try {
      const response = await instance.get<ServiceType[]>('services', {
        headers: { authorization: `Bearer ${token}` },
      })

      return response.data
    } catch (error: any) {
      if (error?.response?.status === 401) {
        return thunkAPI.rejectWithValue('Unauthorized')
      }
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || 'Ошибка при получении служб отеля',
      )
    }
  },
)
